<template>
  <div v-show="!hideButton" @click="openFloatContainer" class="a-vs-b--floating-bubble-wrap" :class="{'open': isOpenFloatContainer, 'has_game_switcher': isGameSwitcherVisible}">
    <div class="ticketpanel_handle" style="pointer-events: none;">
         <div style="pointer-events: all;">
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
          </svg>
        </div>
        <span class='tickets'>{{numberOfTickets}}</span>
      </div>
      <div @click="stopPropagation" v-show="isOpenFloatContainer" class="a-vs-b--ticket-container">
        <!-- Insert tabs with tickets here (bottom tabs) -->
        <vdog-floating-container class="a-vs-ticket-tabs"
          :numberOfTickets="numberOfTickets"
          :numberOfActiveTickets="numberOfActiveTickets"
          :activeStake="activeStake"
          :isBettingEnabled="isBettingEnabled"
          :currency="currency"
          :config="config"
          :roundNo="roundNo"
          :amount="amount"/>
      </div>
  </div>
</template>
<script>

import { eventBus } from '@/main.js'
import { store } from '@/store/store.js'
import EventConstants from '@/constants/Events'
import NumberFormat from '@/mixins/NumberFormat'
import VDogFloatingContent from '@/components/grayhound/floating-tab/VDogFloatingContent.vue'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  components: {
    'vdog-floating-container': VDogFloatingContent
  },
  mixins: [NumberFormat, LanguageHelper],
  props: {
    config: {
      type: Object,
      required: true
    },
    activeStake: {
      type: Object
    },
    isBettingEnabled: {
      type: Boolean
    },
    currency: {
      type: String
    },
    roundNo: {
      type: Number
    },
    showBettingHistory: {
      type: Boolean
    },
    amount: {
      type: Number
    }
  },
  data () {
    return {
      isOpenFloatContainer: false,
      numberOfTickets: 0,
      numberOfActiveTickets: 0,
      hideButton: false
    }
  },
  computed: {
    isGameSwitcherVisible () {
      return store.isGameSwitcherVisible()
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VDOG_CHANGE_PICKS_LENGTH, this.setNumberOfTickets)
    eventBus.$on(EventConstants.VDOG_CONFIRM_ACTIVE_STAKE, this.openFloatContainer)
    eventBus.$on(EventConstants.VDOG_NUMBER_ACTIVE_TICKETS_LENGTH, this.setNumberOfActiveTickets)
    eventBus.$on(EventConstants.VDOG_SHOW_BETTING_HISTORY, this.onEventShowBettingHistory)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VDOG_CHANGE_PICKS_LENGTH, this.setNumberOfTickets)
    eventBus.$off(EventConstants.VDOG_CONFIRM_ACTIVE_STAKE, this.openFloatContainer)
    eventBus.$off(EventConstants.VDOG_NUMBER_ACTIVE_TICKETS_LENGTH, this.setNumberOfActiveTickets)
    eventBus.$off(EventConstants.VDOG_SHOW_BETTING_HISTORY, this.onEventShowBettingHistory)
  },
  methods: {
    stopPropagation () {
      event.stopPropagation()
    },
    setNumberOfActiveTickets (length) {
      this.numberOfActiveTickets = length
    },
    setNumberOfTickets (length) {
      this.numberOfTickets = length
    },
    onEventShowBettingHistory (isOpen) {
      this.hideButton = isOpen
      if (isOpen) {
        if (this.isOpenFloatContainer) {
          this.isOpenFloatContainer = false
        }
      }
    },
    openFloatContainer: function () {
      this.isOpenFloatContainer = !this.isOpenFloatContainer
      if (this.isOpenFloatContainer) {
        eventBus.onGameScrollLock('true')
      } else {
        if (!this.showBettingHistory) {
          eventBus.onGameScrollUnock('true')
        }
      }
    },
    formatCurrency: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    }
  }
}
</script>
